import * as _ from "lodash"
import {LESpendBO} from "./LESpendBO";
import {Role_Administrator} from "../PA.Core/Security/Roles";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class LESpendBOValidations {

    static async ValidateFields(aBO: LESpendBO): Promise<void> {

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_LESpend.cif.CONTROL_POINT_ID),
            "emptyID", "Control Point Id cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_LESpend.cif.CONTROL_POINT_NAME),
            "emptyName", "Control Point Name cannot be empty")

        /*
        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        let bHasCreateRole = userContext.hasRoleId(Role_Administrator)
        let bHasEditorRole = bHasCreateRole

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            bHasCreateRole && aBO.WB_LESpend.isActiveNew,
            "createRole", "Only Users with Editor Role can Create a new Control Point")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            bHasEditorRole && !aBO.WB_LESpend.isActiveNew,
            "createRole", "Only Users with Editor Role can Edit a new Control Point")
        */
    }
}